// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headers[data-v-ec662596]{height:5rem!important;-webkit-box-shadow:0 4px 6px rgba(0,0,0,.1)!important;box-shadow:0 4px 6px rgba(0,0,0,.1)!important;-ms-flex-line-pack:center;align-content:center}", ""]);
// Exports
module.exports = exports;
